<template>
<div class="home">
  <!-- Header -->
  <Header @openForm="openForm" :isPageScroll="isPageScroll" :headColor="headColor" :router="router"></Header>
  <img src="../assets/img/casePage/title-back.png" style="position: absolute;z-index: -1;left:50%;transform: translate(-66%,0);">
  <div class="title">
    <div class="titleName">
      <span>{{articleShow.title}}</span>
      <span id="titleTag" :style="{color: getColor(articleShow.shortTitle).color,background: getColor(articleShow.shortTitle).background}">{{articleShow.shortTitle}}</span>
    </div>
  </div>
  <div class="underTitle"></div>
  <div v-html="articleContent" class="titleContent">{{articleContent}}</div>
  <div class="relatedCases">
    <div class="relatedCasesTitle">相关案例</div>
    <div class="article-box" >
      <div class="customArticle" v-for = "(item) in articleBox " @click="refresh()">
        <router-link :to="{
            path: '/CasePage/CasePageArticle',
            query: {
              id: item.id,
            },
          }">
          <div class = "customImg"><img :src="'http://www.jxdinfo.com'+item.typeImg" style="width: 100%"></div>
          <div class="customArticleTitle">{{ item.title }} <span :style="{color: getColor(item.shortTitle).color,background: getColor(item.shortTitle).background}">{{item.shortTitle}}</span></div>
          <div class="customArticleDesc">{{ item.description }}</div>
        </router-link>
      </div>
    </div>
  </div>
  <!--联系专家-->
  <ContactExperts></ContactExperts>
  <!-- footer -->
  <FhBottom/>
  <!-- 右侧联系方式 -->
  <SideBar @openForm="openForm"></SideBar>
  <!-- 表单 -->
  <HussarForm v-show="showForm" @closeForm="closeForm"></HussarForm>
  <!-- 返回顶部 -->
  <img src="../assets/img/homePage/top.png" class="back-top" @click="backTop" v-if="isPageScroll">
</div>
</template>

<script>
import Header from "./include/Header";
import HussarForm from "./include/HussarForm";
import Footer from "./include/Footer";
import ContactExperts from "./include/ContactExperts";
import {getArticleContent,getContentViewById, getCustomCase} from "../api/casePage";
import SideBar from "./include/SideBar";

export default {
  name: "CasePageArticle",
  data(){
    return{
      router:'/CasePage/CasePageArticle',
      headColor:"dark",
      isPageScroll: false,
      showForm: false,
      article:[],
      articleBox:[],
      articleShow:[],
      articleData: {
        channelId:287,
        pageNo: 1,
        pageSize: 8,
      },
      articleContent:'',
      colorList:[
        {
          name:'新能源',
          color:'#00A2DF',
          background:'#D2F3FF',
        },
        {
          name:'航天航空',
          color:'#2682FF',
          background: '#D2E5FF',
        },
        {
          name:'电力',
          color:'#EC9C23',
          background: '#FFE8C5',
        },
        {
          name:'智能制造',
          color:'#374AEC',
          background:'#D1D6FC'
        },
        {
          name:'建筑工程',
          color:'#7909CE',
          background:'#E9D1FC'
        },
        {
          name:'证券金融',
          color:'#BEB101',
          background:'#FFFBC5',
        },
        {
          name:'通信',
          color:'#E93636',
          background:'#FED2D2'
        },
        {
          name:'能源',
          color:'#009F2A',
          background:'#CBF8D7',
        },{
          name:'轨道交通',
          color:'#00A2DF',
          background:'#D2F3FF',
        },
        {
          name:'石化',
          color:'#308805',
          background:'#DAF8CB',
        },
        {
          name:'有色金属',
          color:'#7909CE',
          background:'#E9D1FC',
        },
        {
          name:'金属冶炼',
          color:'#EFA83E',
          background:'#FFE8C5',
        },
      ],
    }
  },
  components: {
    Header,
    HussarForm,
    Footer,
    SideBar,
    ContactExperts,
  },
  methods: {
    refresh(){
      window.location.reload();
    },
    getColor(name) {
      const self = this;
      let color = '';
      let background = '';
      for(let i = 0; i < self.colorList.length; i++){
        if (self.colorList[i].name === name) {
          color = self.colorList[i].color;
          background = self.colorList[i].background;
          break;
        }
      }
      return {
        color,
        background
      }
    },
    openForm() {
      const self = this;
      self.showForm = true;
    },
    closeForm() {
      const self = this;
      self.showForm = false;
    },
    // 页面滚动
    handleNavScroll() {
      const self = this;
      self.isPageScroll = false;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 80) {
        self.isPageScroll = true;
        self.headColor = 'dark';
      }
    },
    getCustomCase(){
      const self = this;
      getCustomCase(self.articleData).then((res) =>{
        res.data.content.reverse();
        self.article = res.data.content;
        for (let i = 0; i < self.article.length; i++) {
          if(self.article[i].id === self.$route.query.id){
            self.articleShow = self.article[i];
            break;
          }
        }
        const tempArticle = [];
        for (let i = 0; i < self.article.length; i++) {
          if(self.article[i].id !== self.$route.query.id){
            tempArticle.push(self.article[i]);
          }
        }
        const randomList = [];
        for (let i = 0; i < 4; i++) {
          let random = Math.floor(Math.random() * tempArticle.length);
          while (randomList.includes(random)) {
            random = Math.floor(Math.random() * tempArticle.length);
          }
          randomList.push(random);
          self.articleBox.push(tempArticle[random]);
        }
        self.articleBox = self.articleBox.reverse();
        self.articleTotal = res.data.total;
        self.getArticleContent();
      }).catch((error) => {
        self.$message.error('未获取到文章!');
      });
    },
    getArticleContent(){
      const self = this;
      getArticleContent(self.articleShow.id).then((res) =>{
        self.articleContent = res.data;
      }).catch((error) => {
        self.$message.error('未获取到文章内容!');
      });
      getContentViewById(self.articleShow.id).then((res) =>{

      }).catch((error) => {

      });
    },
    // 返回顶部
    backTop() {
      $('html ,body').animate({scrollTop: 0}, 700);
    },

  },
  mounted(){
    const self = this;
    window.addEventListener('scroll', self.handleNavScroll);
    self.getCustomCase();
  }
}
</script>

<style scoped>
.home >>> .navigator > div a:hover,.navigator .isActive {color: #186CF5;}

.title{width:1200px;height:180px;margin: 0 auto;}
.underTitle{width: 1200px;height:20px;border-bottom: 1px rgba(227, 227, 227, 1) solid;margin:0 auto;}
.titleName{width:1200px;padding-top:140px;margin: 0 auto;font-size: 30px;font-weight: bold;color: #3E3A39;float: left;}
.titleName span{text-align:center;width:150px;border-left:5px #186CF5 solid; display: inline-block;}
.titleContent{width:1200px;margin:40px auto;}
.relatedCases{height:630px;background: rgba(249, 251, 254, 1)}
.relatedCasesTitle{padding-top:40px;width:200px;margin:0px auto 50px;font-size: 34px;font-weight: bold;color: #2E2E2E;}
.article-box{width:1230px;margin: 0 auto;height:500px;}
.customCase{width: 100%;background: rgba(249, 251, 254, 1)}
.customTitle{text-align:center;height:50px;font-size: 34px;font-weight: bold;color: #2E2E2E;margin: 80px auto 50px;}
.article-box{width:1230px;margin: 0 auto;height:820px}
.customArticle{width:275px;height:365px;box-shadow: 0px 0px 10px 1px rgba(0,65,178,0.16);border-radius:5px;float: left;margin: 0 15px 50px;}
.customArticle:hover{transform: translate(0,-10px);transition: all 500ms ease;}
.customImg{width:275px;height: 190px;box-shadow: none;}
.customImg img{width: 100%;height: 100%;border-radius: 5px 5px 0 0 ;}
.customArticleTitle{margin-left: 25px;margin-top: 25px;font-size: 16px;font-weight: bold;color: #2E2E2E;}
.customArticleTitle span{margin-left:8px;font-size: 12px;border-radius: 5px;font-weight: normal;display: inline-block;padding: 0 10px;height: 22px;text-align: center;line-height: 22px;}
.customArticleDesc{font-size:14px;margin-left: 25px;margin-top: 17px;width:230px;height:65px;color: #2E2E2E;line-height: 23px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp:3;-webkit-box-orient: vertical;}
/*.customArticle{width:275px;height:385px;box-shadow: 0px 0px 10px 1px rgba(0,65,178,0.16);float: left;margin: 0 15px 50px;border-radius:5px;}*/
/*.customArticle:hover{transform: translate(0,-10px);transition: all 500ms ease;}*/
/*.customImg{width:275px;height: 190px;}*/
/*.customImg img{width: 100%;height: 100%;border-radius: 5px 5px 0 0 ;}*/
/*.customArticleTitle{margin-left: 25px;margin-top: 25px;font-size: 16px;font-weight: bold;color: #2E2E2E;}*/
/*.customArticleTitle span{margin-left:8px;font-size: 12px;border-radius: 5px;font-weight: normal;display: inline-block;padding:0 10px;height: 22px;text-align: center;line-height: 22px;}*/
#titleTag{border:none;margin-left:-3px;font-size: 12px;border-radius: 5px;font-weight: normal;display: inline-block;width: 70px;height: 22px;text-align: center;line-height: 22px;}
.customArticleDesc{margin-left: 25px;margin-top: 17px;width:230px;height:65px;color: #2E2E2E;}
/* 返回顶部 */
.back-top {position: fixed;top: calc(40% + 250px);right: 5px;cursor: pointer;}
.home>>> .contact-box{background: url('../assets/img/casePage/contact-bg.jpg') no-repeat 50%;}
/*取消页面光标*/
.model-box div,img{caret-color: transparent;}
</style>



// WEBPACK FOOTER //
// src/components/CasePageArticle.vue